(function () {
  'use strict';
  // NDK FR 27-sep-2026: COPIE de assets/ndk-search.js de IT live (= logique ES, master, du 26/27-sep). La logique est identique ; seule change
  // la partie de langue (crise, mots vides, «femme», meilleures ventes, messages, exemples, market, «vit» → vitamine) + trois règles FR
  // marquées «FR:» (revue 27-sep). Vérifié par ~/naturadika-buscador/scripts/fr/langue.test.mjs.

  /* ── BEGIN MATCHER ── copia literal de naturadika-tools/scripts/search/matcher.mjs
     Si tocas uno, toca el otro y vuelve a correr matcher.test.mjs ── */
  function norm(s) {
    return (s || '')
      .toLowerCase()
      .replace(/œ/g, 'oe').replace(/æ/g, 'ae') // FR: «cœur», «sœur» (NFD ne décompose pas les ligatures)
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/(^| )vit(?= |$)/g, '$1vitamine'); // «vit. b12», «vit c» (26-sep-2026)
  }

  function closeEnough(a, b, max) {
    if (a === b) return true;
    if (Math.abs(a.length - b.length) > max) return false;
    var prev = new Array(b.length + 1);
    for (var j = 0; j <= b.length; j++) prev[j] = j;
    for (var i = 1; i <= a.length; i++) {
      var diag = prev[0];
      prev[0] = i;
      var best = prev[0];
      for (var k = 1; k <= b.length; k++) {
        var tmp = prev[k];
        prev[k] = Math.min(prev[k] + 1, prev[k - 1] + 1, diag + (a[i - 1] === b[k - 1] ? 0 : 1));
        diag = tmp;
        if (prev[k] < best) best = prev[k];
      }
      if (best > max) return false;
    }
    return prev[b.length] <= max;
  }

  // Coincidencia por PALABRA ENTERA: «flora» no casa dentro de «pasiflora», «sol» no dentro de «verisol».
  function hitsWord(nq, np) {
    return !!np && (' ' + nq + ' ').indexOf(' ' + np + ' ') !== -1;
  }
  function hitsPattern(nq, patrones) {
    if (!patrones) return false;
    for (var i = 0; i < patrones.length; i++) {
      if (hitsWord(nq, norm(patrones[i]))) return true;
    }
    return false;
  }

  function ordenar(lista, nq) {
    // nombre exacto: el título o un alias igual a la consulta («skin» → Skincoll, 26-sep-2026)
    function exacto(p) { return norm(p.t) === nq || (p.alias || []).some(function (x) { return norm(x) === nq; }); }
    return lista.slice().sort(function (a, b) {
      var na = norm(a.t), nb = norm(b.t), ea = exacto(a), eb = exacto(b);
      if (ea !== eb) return ea ? -1 : 1;
      // palabra entera del título antes que trozo de palabra: «men» → Men Complex antes que Meno Essence (26-sep-2026)
      var pa = hitsWord(na, nq) ? 0 : 1, pb = hitsWord(nb, nq) ? 0 : 1;
      if (pa !== pb) return pa - pb;
      // luego una palabra que EMPIEZA por la consulta: «om» → Full Omega antes que «cOMplex» (27-sep-2026)
      var sa = (' ' + na).indexOf(' ' + nq) !== -1 ? 0 : 1, sb = (' ' + nb).indexOf(' ' + nq) !== -1 ? 0 : 1;
      if (sa !== sb) return sa - sb;
      return na.length - nb.length;
    });
  }

  // Productos NOMBRADOS dentro de una frase de 2+ palabras («tribulus maca influyen en la presion arterial»): palabra propia
  // del título (no genérica, ≥4 letras) como palabra entera. Médico y sensibles se miran antes. Decisión de Paolo 26-sep-2026:
  // si nombra el producto, se enseña el producto; la ficha ya dice cuándo no se aconseja.
  // Inglés frecuente → idioma de la tienda (28-sep-2026): «man boost», «thorne men's multi». Solo si nada más encaja.
  var INGLES = { man: 'homme', men: 'homme', mens: 'homme', male: 'homme', woman: 'femme', women: 'femme', female: 'femme', sleep: 'sommeil', hair: 'cheveux', energy: 'energie', tired: 'fatigue', tiredness: 'fatigue', fatigue: 'fatigue', multi: 'vitamines', multivitamin: 'vitamines', multivitamins: 'vitamines', vitamins: 'vitamines', weight: 'poids', bloating: 'ballonnements', gut: 'intestin', memory: 'memoire', focus: 'concentration', immune: 'immunite', immunity: 'immunite', collagen: 'collagene', iron: 'fer', stress: 'stress', menopause: 'menopause', probiotics: 'probiotiques' };
  var GENERICAS_TITULO = ['plus','complex','balance','boost','booster','skin','expert','beauty','strong','summer','anti','aging',
    'serum','active','advanced','brain','power','stress','control','essence','nighttime','forte','full','green','vita','long','sensation'];
  // Códigos del título con número cuentan aunque sean cortos: «b12 b6» → VivaCel B12, «d3» → DuoWell (28-sep-2026).
  function productosNombrados(nq, productos, comunes) {
    if (nq.split(' ').length < 2) return [];
    var out = [];
    for (var i = 0; i < productos.length; i++) {
      if (productos[i].disp === false) continue;
      var pals = norm(productos[i].t).split(' '), n = 0;
      for (var j = 0; j < pals.length; j++) {
        if (((pals[j].length >= 4 && GENERICAS_TITULO.indexOf(pals[j]) === -1) || (pals[j].length >= 2 && /\d/.test(pals[j]))) && hitsWord(nq, pals[j])) n++;
      }
      // alias dentro de la frase: «kijimea k53» → Probiotic Balance (28-sep-2026). Solo nombres propios: un alias que es
      // palabra corriente (sale en los sinónimos de alguna necesidad: «hombre», «femme») no cuenta dentro de una frase.
      (productos[i].alias || []).forEach(function (a) {
        var na = norm(a);
        if (na.length >= 4 && hitsWord(nq, na) && !na.split(' ').some(function (w) { return comunes && comunes[w]; })) n++;
      });
      if (n) out.push({ p: productos[i], n: n });
    }
    out.sort(function (a, b) { return b.n - a.n; });
    return out.map(function (x) { return x.p; });
  }

  // Ingredientes palabra por palabra (28-sep-2026), no por trozos: «pranarom» no es «NAR», «manos» no es «D-Manosa»;
  // y «curcuma latte» sí encuentra «Extracto seco de Cúrcuma». Las palabras genéricas de las etiquetas no cuentan solas.
  var GENERICAS_ING = ['extracto','estratto','extrait','extract','seco','seca','secco','sec','acido','acide','polvo','polvere','poudre','base',
    'raiz','radice','racine','hoja','hojas','foglie','feuilles','fruto','frutto','fruit','semillas','semi','graines','vitamina','vitamine','vitamin',
    'complejo','complesso','complexe','natural','naturale','naturel',
    'rojo','roja','rosso','rossa','rouge','negro','negra','blanco','blanca','bianco','bianca','blanc','blanche','verde','amarillo','amarilla',
    'giallo','gialla','jaune','aceite','olio','huile','oil','essentielle','esencial','essenziale','equilibrio','equilibre','bienestar','benessere','bien','americano','americana','americain','americaine','organico','organica','biologico','biologica','biologique'];
  function encajaIngrediente(nq, ni, comunes) {
    if (hitsWord(nq, ni) || (GENERICAS_ING.indexOf(nq) === -1 && hitsWord(ni, nq))) return true;
    var q = nq.split(' '), w = ni.split(' ');
    // escribiendo: «magn» → magnesio; pero si solo faltan 1-2 letras es otra palabra («manos» no es «manosa»)
    if (q.length === 1 && nq.length >= 4 && w.some(function (x) { return x.indexOf(nq) === 0 && x.length - nq.length >= 3; })) return true;
    // una palabra corriente (de los sinónimos: «femme») no basta sola: «SynActive Femme» no es «flemme»→«femme»
    return q.some(function (t) { return t.length >= 5 && GENERICAS_ING.indexOf(t) === -1 && !(comunes && comunes[t]) && w.indexOf(t) !== -1; });
  }

  // Red de seguridad de crisis (revisión 25-sep-2026): variantes y erratas habituales que la lista «crisis» (palabra entera)
  // no cubre: «quiero morir», «pensamientos suicidas», «autolesiones», «suisidio»… El texto de la respuesta sigue siendo el de la lista.
  var CRISIS_RE = /(^| )(suicid\w*|suicd\w*|sucid\w*|suisid\w*|suiscid\w*|automutil\w*|auto mutil\w*|scarifi\w*|me mutile\w*|me mutiler|(je veux|je veu|je veut|je ve|j veux|jveux|jveu|jveut|jvx|jve|je voudrais|je voudrai|j ai envie de|j ai envi de|jai envie de|jai envi de|g envie de|envie de|envi de|j aimerais|je prefererais|je souhaite) (mourir|mourrir|mourire|mourrire|crever)(?! (de|d) (rire|faim|soif|chaud|froid|honte|ennui|fatigue|envie|jalousie|peur|plaisir))|(comment|moyen|moyens|methode|facon|maniere|chose|quelque chose|dose|cachets|comprimes|pilules|somniferes|melatonine) (pour|de|d) mourir(?! (de|d) (rire|faim|soif|chaud|froid|honte|ennui|fatigue|envie|jalousie|peur|plaisir))|(mourir|me tuer|se tuer|partir) (sans souffrir|sans douleur|sans souffrance|dans mon sommeil|en dormant)|comment (se|me) (tuer|suicider|pendre|foutre en l air)|comment mourir|dose (mortelle|letale)|letale?(?= *$| dose)|(je veux|je voudrais|je cherche) la mort|je pense (a la mort|a mourir)|mieux vaut (mourir|que je meure)|(plus|plu|pas|aucune|sans) (envie|raison|gout) (de|d|a) (vivre|la vie)(?! (avec|comme|ainsi|dans|en|a))|(plus|plu|aucun) gout (a|de) (la vie|vivre|rien)(?= *$)|(je ne veux|je veux|je veut|jveux|jveut|je voudrais) (plus|plu|pas) vivre|marre de (vivre|la vie)(?= *$)|(fatigue|fatiguee|lasse|las|epuise|epuisee) de (vivre|la vie)(?= *$)|en peux plus de (vivre|la vie|exister)|vie (n a|na) (plus )?(aucun |de |pas de )?sens|(plus|pas) envie d exister|ne plus exister|(je veux|je voudrais) (ne )?plus exister|a quoi bon vivre|en finir(?= *$| avec (la vie|ma vie|tout|moi|l existence|le monde)| une bonne fois| pour de bon)|mettre fin a (mes jours|ma vie|tout|mon existence)|(me tuer|me suicider|me buter|me flinguer|me foutre en l air)(?! (au|a la|a|de|en) (travail|boulot|tache|sport|salle|rire|fatigue))|me pendre|se pendre|pendaison|corde pour (me|se) pendre|me jeter (du|d un|d une|par la|sous|dans le vide)|sauter (du|d un|d une) (pont|balcon|immeuble|toit|fenetre|falaise)|sauter (par|de) la fenetre|je vais sauter(?= *$| du | d un | d une | par )|me tirer une balle|m empoisonner|je vais me noyer|me noyer(?= *$)|(avaler|prendre) (toute la boite|toutes les|tous les|tous mes|toutes mes|la boite de) (de )?(pilules|cachets|comprimes|medicaments|somniferes)(?= *$| d un coup| en une fois| pour (mourir|en finir))|(overdose|surdose) (de|d) (somniferes|medicaments|cachets|comprimes|pilules|melatonine)|combien de (cachets|comprimes|gelules|pilules|somniferes|melatonine) pour (mourir|ne plus (me|se) reveiller)|(ne plus|ne jamais|plus jamais|jamais plus) (me|se) reveiller(?= *$| de ma vie)|(je veux|je voudrais|j aimerais|je veut) (ne )?plus (me|jamais me) reveiller(?= *$)|(dormir|m endormir) pour toujours(?= *$)|sommeil eternel|disparaitre (pour toujours|a jamais|pour de bon)(?= *$)|(envie de|je veux|je voudrais|j aimerais|je veut) disparaitre(?! (les|la|le|mes|ma|mon|ces|cette|ce|l|des|du|de) )|(serait|seraient|serais|sera|seront) mieux sans moi|(je (ne )?sers|j sers|jsers|je sert) a (rien|r1)(?= *$| a personne| pour personne| dans (ma|la) vie)|(je suis|j suis|jsuis|je me sens) (un|une) (poids|fardeau)(?! (lourd|plume|ideal|en trop|de|d))|(un|une) (poids|fardeau) pour (tout le monde|ma famille|les autres|mes proches|mon entourage)|(plus|aucun|aucune) (d )?(espoir|issue)(?= *$)|je ne vois (plus )?(d |aucune )?issue|je veux que tout s arrete|idees noires|pensees noires|(pensees|idees) (suicidaires|de mort)|(me faire|je me fais|je me fait|m faire) du mal(?! (au|a la|aux|a l|en|avec) )|me couper (les veines|les poignets|les bras|les cuisses)|je me coupe(?= *$| les (bras|poignets|veines|cuisses|jambes))|je me suis coupee?(?= *$| les (bras|poignets|veines))|je me brule(?= *$| la peau| les bras| volontairement))( |$)/;
  // Reserva de seguridad: si falta el metaobject «crisis» o está en DRAFT (los creados por API nacen así), el mensaje sale igual.
  // IT (fonte telefonoamico.it, 25-sep-2026: 02 2327 2327, tutti i giorni 24 ore su 24; WhatsApp 324 011 7252)
  var CRISIS_RESPUESTA = 'Si tu traverses un moment très difficile, appelle le 3114, 24h/24 et 7j/7, gratuitement. En cas de danger immédiat, appelle le 15 ou le 112.';

  var MAS_VENDIDOS_Q = ['meilleures ventes', 'meilleure vente', 'les meilleures ventes', 'plus vendus', 'les plus vendus', 'produits les plus vendus', 'le plus vendu',
    'top ventes', 'best seller', 'bestseller', 'best sellers', 'bestsellers'];
  function resolve(q, index, corregida) {
    var nq = norm(q);
    if (!nq) return { tipo: 'vacio' };

    // Crisis (suicidio, autolesión): antes que nada, con el teléfono 024. Revisión del 25-sep-2026.
    if ((index.crisis && hitsPattern(nq, index.crisis.patrones)) || CRISIS_RE.test(nq)) {
      return { tipo: 'sensible', lista: 'crisis', respuesta: (index.crisis && index.crisis.respuesta) || CRISIS_RESPUESTA };
    }
    // Necesidades marcadas «sobre sensibles» (p. ej. fertilidad masculina → Tribulus, vista fertilidad): se miran ANTES
    // de las listas de sistema, solo por frase de sinónimo completa. Decisión de Paolo 25-sep-2026.
    var nec0 = index.necesidades || [];
    for (var s0 = 0; s0 < nec0.length; s0++) {
      if (!nec0[s0].sobre_sensibles) continue;
      var sin0 = nec0[s0].sinonimos || [];
      for (var s1 = 0; s1 < sin0.length; s1++) {
        var ns0 = norm(sin0[s1]);
        if (ns0 && (ns0 === nq || hitsWord(nq, ns0))) {
          // lo que queda de la consulta no puede ser otro tema del médico/sensible ni hablar de la mujer («calidad del semen y quimioterapia», «fertilidad hombre y mujer»)
          var resto = (' ' + nq + ' ').replace(' ' + ns0 + ' ', ' ').trim();
          var otroSensible = (index.medico && hitsPattern(resto, index.medico.patrones)) || (index.sensibles && hitsPattern(resto, index.sensibles.patrones));
          if (!otroSensible && !/(^| )(femme|femmes|feminin|feminine|feminins|feminines)( |$)/.test(resto)) return { tipo: 'necesidad', necesidad: nec0[s0], q: nq };
        }
      }
    }
    // Enfermedades y consultas para el médico (Alzheimer, fertilidad sin más…): mensaje propio, sin productos.
    if (index.medico && hitsPattern(nq, index.medico.patrones)) {
      return { tipo: 'sensible', lista: 'medico', respuesta: index.medico.respuesta };
    }
    if (index.sensibles && hitsPattern(nq, index.sensibles.patrones)) {
      return { tipo: 'sensible', lista: 'sensibles', respuesta: index.sensibles.respuesta };
    }
    if (index.cortesias && (index.cortesias.patrones || []).some(function (p) { return norm(p) === nq; })) {
      return { tipo: 'cortesia', respuesta: index.cortesias.respuesta };
    }

    // «más vendidos»: consulta exacta (chip del menú o escrita). La lista la carga la capa de pintado.
    if (MAS_VENDIDOS_Q.indexOf(nq) !== -1) return { tipo: 'mas-vendidos' };

    // atajos de servicio (envío, pedido, contacto…): antes que productos, por subcadena
    var atajos = index.atajos || [];
    for (var ai = 0; ai < atajos.length; ai++) {
      if (hitsPattern(nq, atajos[ai].patrones)) return { tipo: 'atajo', atajo: atajos[ai] };
    }

    var tokens = nq.split(' ');
    var productos = index.productos || [];
    var necesidades = index.necesidades || [];
    var i, j, k;

    // plural = singular (27-sep-2026): «vitaminas» encuentra lo mismo que «vitamina»; y «fatigues» la lista
    //   de «fatigue»: el singular se prueba contra los alias (1), los sinónimos (2) y los subtítulos (2b)
    var singulares = (tokens.length === 1 && nq.length >= 6 && nq.charAt(nq.length - 1) === 's')
      ? [nq.slice(0, -1)].concat(/es$/.test(nq) ? [nq.slice(0, -2)] : []).filter(function (s) { return s.length >= 5; }) : [];
    // 1. producto por coincidencia EXACTA de texto
    var hallados = [];
    var nqs = nq.replace(/ /g, '');
    // una palabra corta que ya es sinónimo exacto de una necesidad va a su lista, no al producto que empieza igual («fer» → fer, no FerMax)
    var cortaEsNecesidad = nq.length < 4 && necesidades.some(function (n) { return (n.sinonimos || []).some(function (x) { return norm(x) === nq; }); });
    var palabrasTitulo = {};
    for (i = 0; i < productos.length; i++) norm(productos[i].t).split(' ').forEach(function (w) { if (w.length >= 3) palabrasTitulo[w] = 1; });
    for (i = 0; i < productos.length; i++) {
      var np = norm(productos[i].t), nps = np.replace(/ /g, '');
      // con menos de 4 letras: al principio de una palabra, o dentro si lo de delante es otra palabra de nuestros nombres
      // («col» → Skin|coll sí; «gin» → a|gin|g y «to» → de|to|x no) (29-sep-2026)
      // un código con número va entero: «b1» no es «B12»
      var enTitulo = /\d/.test(nq) && nq.length < 4 ? hitsWord(np, nq) : nq.length >= 4 ? np.indexOf(nq) !== -1 : !cortaEsNecesidad && ((' ' + np).indexOf(' ' + nq) !== -1 ||
        (nq.length === 3 && np.split(' ').some(function (w) { var k = w.indexOf(nq); return k > 0 && palabrasTitulo[w.slice(0, k)]; })));
      if (np === nq || enTitulo || nq.indexOf(np) !== -1 || (nqs.length >= 5 && nps.indexOf(nqs) !== -1)) { hallados.push(productos[i]); continue; }
      // todas las palabras de la consulta están en el título, en cualquier orden: «skin boost» → Sun Boost Summer Skin (27-sep-2026)
      if (tokens.length >= 2 && tokens.every(function (w) { return w.length >= 3 && hitsWord(np, w); })) { hallados.push(productos[i]); continue; }
      var al = productos[i].alias || [];
      for (j = 0; j < al.length; j++) { if (norm(al[j]) === nq || singulares.indexOf(norm(al[j])) !== -1) { hallados.push(productos[i]); break; } }
    }
    if (hallados.length) return { tipo: 'producto', productos: ordenar(hallados, nq), producto: ordenar(hallados, nq)[0] };

    // 2. necesidad por sinónimo EXACTO — gana la coincidencia más larga.
    //    Va ANTES de la búsqueda aproximada de producto: "memoria" es la necesidad,
    //    no una errata de "Memor Tropic"; "estres" es la necesidad, no "Stress Control".
    var mejor = null, mejorPuntos = 0;
    for (i = 0; i < necesidades.length; i++) {
      var sin = necesidades[i].sinonimos || [];
      for (j = 0; j < sin.length; j++) {
        var ns = norm(sin[j]);
        if (!ns) continue;
        var puntos = 0;
        if (ns === nq || singulares.indexOf(ns) !== -1) puntos = 1000 + ns.length;
        else if (hitsWord(nq, ns)) puntos = ns.length;
        if (puntos > mejorPuntos) { mejorPuntos = puntos; mejor = necesidades[i]; }
      }
    }
    if (mejor) return { tipo: 'necesidad', necesidad: mejor, q: nq };

    // 2b. producto por su subtítulo aprobado ("nad+", "colágeno hidrolizado", "omega 3").
    //     Palabra suelta: token igual (o prefijo si ≥5). Frase: subcadena del subtítulo.
    var STOP = ['complement','complements','gelule','gelules','capsule','capsules','alimentaire','alimentaires','naturel','naturelle','naturels','naturelles','pour','avec','de','du','des','la','le','les','l','d','un','une','en','sans','et','a','au','aux','ton','ta','mon','ma','mes'];
    if (nq.length >= 3 && STOP.indexOf(nq) === -1) {
      var porSub = [];
      for (i = 0; i < productos.length; i++) {
        if (productos[i].disp === false) continue;
        var nsub = norm(productos[i].sub || '');
        if (!nsub) continue;
        var pos = -1;
        if (tokens.length > 1) { pos = nsub.indexOf(nq); }
        else {
          var toks = nsub.split(' '), acc = 0;
          for (j = 0; j < toks.length; j++) {
            if (toks[j] === nq || (nq.length >= 5 && toks[j].indexOf(nq) === 0) ||
                (singulares.length && singulares.some(function (s) { return toks[j] === s || toks[j].indexOf(s) === 0; }))) { pos = acc; break; }
            acc += toks[j].length + 1;
          }
        }
        if (pos !== -1) porSub.push({ p: productos[i], pos: pos });
      }
      if (porSub.length) {
        porSub.sort(function (a, b) { return a.pos - b.pos || norm(a.p.t).length - norm(b.p.t).length; });
        var lista = porSub.map(function (x) { return x.p; });
        return { tipo: 'producto', productos: lista, producto: lista[0] };
      }
    }

    // 3. producto por aproximación (erratas: "magwel")
    if (tokens.length <= 2) {
      for (i = 0; i < productos.length; i++) {
        var partes = norm(productos[i].t).split(' ');
        for (j = 0; j < partes.length; j++) {
          if (partes[j].length >= 5 && closeEnough(nq, partes[j], 1)) { hallados.push(productos[i]); break; }
        }
      }
      if (hallados.length) return { tipo: 'producto', productos: hallados, producto: hallados[0] };
    }

    // 3b. nombre de producto con una letra mal dentro de una frase: «man complex» → Men Complex (29-sep-2026)
    if (tokens.length >= 2 && nq.length >= 8) {
      var casi = [];
      for (i = 0; i < productos.length; i++) {
        var pw = norm(productos[i].t).split(' ');
        for (j = 0; j + tokens.length <= pw.length; j++) {
          if (closeEnough(nq, pw.slice(j, j + tokens.length).join(' '), 1)) { casi.push(productos[i]); break; }
        }
      }
      if (casi.length) return { tipo: 'producto', productos: casi, producto: casi[0] };
    }

    // 4. necesidad por aproximación ("insomnnio")
    if (tokens.length <= 2) {
      for (i = 0; i < necesidades.length; i++) {
        var sin2 = necesidades[i].sinonimos || [];
        for (j = 0; j < sin2.length; j++) {
          var ns2 = norm(sin2[j]);
          if (ns2.length >= 5 && closeEnough(nq, ns2, 1)) return { tipo: 'necesidad', necesidad: necesidades[i] };
        }
      }
    }

    // 4b. producto NOMBRADO dentro de una frase ("tribulus maca influyen en la presion arterial"). Ver productosNombrados().
    var comunes = {};
    for (i = 0; i < necesidades.length; i++) (necesidades[i].sinonimos || []).forEach(function (x) { norm(x).split(' ').forEach(function (w) { comunes[w] = 1; }); });
    var listaN = productosNombrados(nq, productos, comunes);
    if (listaN.length) return { tipo: 'producto', productos: listaN, producto: listaN[0] };

    if ((nq.length >= 4 || (nq.length >= 2 && /\d/.test(nq))) && nq.indexOf('sans ') !== 0) { // «b6» (28-sep-2026)
      var porIng = [];
      for (i = 0; i < productos.length; i++) {
        if (productos[i].disp === false) continue;
        var ings = productos[i].ing || [];
        for (j = 0; j < ings.length; j++) {
          var ni = norm(ings[j]);
          if (ni && encajaIngrediente(nq, ni, comunes)) { porIng.push({ p: productos[i], ni: ni }); break; }
        }
      }
      // primero el producto que lleva el ingrediente en el nombre o el subtítulo (magnesio → MagWell), luego el resto
      if (porIng.length) {
        var delIng = function (x) { return hitsWord(norm(x.p.t + ' ' + (x.p.sub || '')), x.ni) ? 0 : 1; };
        porIng = porIng.map(function (x, n) { return { x: x, n: n }; })
          .sort(function (a, b) { return delIng(a.x) - delIng(b.x) || a.n - b.n; })
          .map(function (y) { return y.x.p; });
        return { tipo: 'ingrediente', productos: porIng };
      }
    }

    var paginas = index.paginas || [];
    for (i = 0; i < paginas.length; i++) {
      var npg = norm(paginas[i].t);
      // por palabra o principio de palabra, no por trozos: «tos» no es «daTOS» (28-sep-2026)
      if (npg && npg.length >= 4 && (hitsWord(nq, npg) || (' ' + npg).indexOf(' ' + nq) !== -1)) {
        return { tipo: 'pagina', pagina: paginas[i] };
      }
    }

    // 5. erratas («citrato di mavnesio», «reverastrol»): cada palabra de ≥5 letras que no existe se cambia por la del
    //    vocabulario del índice a 1 letra de distancia (a 2 si ambas tienen ≥8 letras), y se vuelve a resolver UNA vez.
    //    Frases de 3+ palabras (26-sep-2026); desde el 27-sep también 1-2 palabras, que así alcanzan ingredientes y subtítulos,
    //    y palabras de 4 letras («zink» → zinc: grafías de otros idiomas). Un plural que no existe pasa antes a su singular.
    if (!corregida) {
      var vocab = {}, poner = function (s) { norm(s).split(' ').forEach(function (w) { if (w.length >= 4) vocab[w] = 1; }); };
      for (i = 0; i < productos.length; i++) {
        poner(productos[i].t); poner(productos[i].sub); (productos[i].ing || []).forEach(poner);
      }
      for (i = 0; i < necesidades.length; i++) (necesidades[i].sinonimos || []).forEach(poner);
      var palabras = Object.keys(vocab), cambiada = false;
      // grafía equivalente por cómo suena (k/c/qu, z/s, y/i, v/b, h muda): «zink», «sinc», «kreatina». Es la única corrección
      // para palabras de 4 letras: con «una letra distinta» salían «miel» → piel o «casa» → cara.
      var suena = function (x) {
        return x.replace(/qu/g, 'k').replace(/c(?=[ei])/g, 's').replace(/c/g, 'k').replace(/z/g, 's')
          .replace(/y/g, 'i').replace(/v/g, 'b').replace(/h/g, '');
      };
      var porSonido = {};
      palabras.forEach(function (p) { if (!porSonido[suena(p)]) porSonido[suena(p)] = p; });
      var nuevos = tokens.map(function (w) {
        if (w.length < 4 || vocab[w]) return w;
        if (w.length >= 6 && /s$/.test(w)) {
          if (vocab[w.slice(0, -1)]) { cambiada = true; return w.slice(0, -1); }
          if (/es$/.test(w) && vocab[w.slice(0, -2)]) { cambiada = true; return w.slice(0, -2); }
        }
        if (porSonido[suena(w)]) { cambiada = true; return porSonido[suena(w)]; }
        if (w.length < 6) return w; // 4-5 letras: solo por sonido («manos» no es una errata de «manosa»)
        for (var v = 0; v < palabras.length; v++) {
          // las palabras de 4 letras del vocabulario solo valen por sonido: «testa» no es «tesa»
          if (palabras[v].length >= 5 && closeEnough(w, palabras[v], 1)) { cambiada = true; return palabras[v]; }
        }
        if (w.length >= 8) {
          for (v = 0; v < palabras.length; v++) {
            if (palabras[v].length >= 8 && closeEnough(w, palabras[v], 2)) { cambiada = true; return palabras[v]; }
          }
        }
        return w;
      });
      if (cambiada) {
        var r2 = resolve(nuevos.join(' '), index, true);
        if (r2.tipo !== 'desconocido') return r2;
      }
    }

    // 6. palabras en inglés frecuentes → idioma de la tienda, y se vuelve a resolver una vez (28-sep-2026)
    if (!corregida) {
      var trad = tokens.map(function (w) { return INGLES.hasOwnProperty(w) ? INGLES[w] : w; }).join(' ');
      if (trad !== nq) {
        var r3 = resolve(trad, index, true);
        if (r3.tipo !== 'desconocido') return r3;
      }
    }

    // 7. palabras pegadas y palabras desconocidas (28-sep-2026): «traeskincoll» → «trae skincoll»; «colageno selectium»
    //    → «colageno»; «kenge men» → «men». Se separa lo pegado, se quita lo que no existe en el índice y se resuelve una vez.
    if (!corregida) {
      var conocidas = {}, marca = function (x) { norm(x || '').split(' ').forEach(function (w) { if (w) conocidas[w] = 1; }); };
      for (i = 0; i < productos.length; i++) {
        marca(productos[i].t); marca(productos[i].sub); (productos[i].ing || []).forEach(marca); (productos[i].alias || []).forEach(marca);
      }
      for (i = 0; i < necesidades.length; i++) (necesidades[i].sinonimos || []).forEach(marca);
      // nombres de producto y de ingrediente («demanosa» → «de manosa», 30-sep-2026); primero los más largos
      var nombresProd = [], anota = function (w) { if (w.length >= 5 && nombresProd.indexOf(w) === -1) nombresProd.push(w); };
      for (i = 0; i < productos.length; i++) {
        norm(productos[i].t).split(' ').forEach(function (w) { if (GENERICAS_TITULO.indexOf(w) === -1) anota(w); });
        (productos[i].ing || []).forEach(function (x) { norm(x).split(' ').forEach(function (w) { if (GENERICAS_ING.indexOf(w) === -1) anota(w); }); });
      }
      nombresProd.sort(function (a, b) { return b.length - a.length; });
      var partes = [];
      tokens.forEach(function (w) {
        if (conocidas[w] || w.length < 8) { partes.push(w); return; }
        for (var q = 0; q < nombresProd.length; q++) {
          var pn = nombresProd[q];
          if (w.length > pn.length + 1 && w.slice(-pn.length) === pn) { partes.push(w.slice(0, -pn.length), pn); return; }
          if (w.length > pn.length + 1 && w.slice(0, pn.length) === pn) { partes.push(pn, w.slice(pn.length)); return; }
        }
        partes.push(w);
      });
      var utiles = partes.filter(function (w) { return conocidas[w]; });
      var resto = utiles.join(' ');
      // tiene que quedar una palabra con significado propio: «huile de cbd» → «huile» sola no lleva a Omega
      if (resto && resto !== nq && utiles.some(function (w) {
        return w.length >= 3 && STOP.indexOf(w) === -1 && GENERICAS_ING.indexOf(w) === -1 && GENERICAS_TITULO.indexOf(w) === -1;
      })) {
        // solo lleva a productos, listas, ingredientes o atajos: quitar palabras puede cambiar el sentido («mi faccio del male
        // alla schiena» sin «alla schiena» sería una frase de crisis), así que un mensaje sensible aquí no vale
        var r4 = resolve(resto, index, true);
        if (['producto', 'necesidad', 'ingrediente', 'atajo'].indexOf(r4.tipo) !== -1) return r4;
      }
    }

    return { tipo: 'desconocido', q: nq };
  }
  // El chip responde a lo que escribiste: si la consulta comparte una palabra con uno de los
  // tags aprobados del producto, ese es el chip. Si no, el de por defecto. Nunca texto nuevo.
  var STOP_CHIP = ['la','le','les','de','du','des','et','en','avec','pour','sans','un','une','que','qui','mon','ma','mes','ton','ta','tes','au','aux','par','sur','est','pas','plus'];
  function tokensUtiles(s) {
    return norm(s).split(' ').filter(function (t) { return t.length >= 3 && STOP_CHIP.indexOf(t) === -1; });
  }
  function parecidos(a, b) {
    return a === b || (a.length >= 5 && b.length >= 5 && a.slice(0, 4) === b.slice(0, 4));
  }
  function elegirChip(item, nq) {
    var tags = item.tags || [];
    if (!tags.length || !nq) return { chip: item.etiqueta, hit: false };
    var qt = tokensUtiles(nq), mejor = null, mejorN = 0;
    for (var i = 0; i < tags.length; i++) {
      var tt = tokensUtiles(tags[i]), n = 0;
      for (var a = 0; a < qt.length; a++) {
        for (var b = 0; b < tt.length; b++) { if (parecidos(qt[a], tt[b])) { n++; break; } }
      }
      if (n > mejorN) { mejorN = n; mejor = tags[i]; }
    }
    // la etiqueta curada compite con los tags: con vista, suele describir mejor el resultado que el tag genérico
    var et = tokensUtiles(item.etiqueta || ''), nE = 0;
    for (var a2 = 0; a2 < qt.length; a2++) {
      for (var b2 = 0; b2 < et.length; b2++) { if (parecidos(qt[a2], et[b2])) { nE++; break; } }
    }
    return mejor && mejorN > nE ? { chip: mejor, hit: true } : { chip: item.etiqueta, hit: false };
  }
  // Chips de una lista entera: el adaptativo no puede hacer que dos productos digan lo mismo.
  // Si el chip elegido ya lo lleva otro producto de la lista, este conserva el suyo por defecto.
  function chipsDeLista(items, nq) {
    var usados = {}, out = [], i;
    for (i = 0; i < items.length; i++) {
      var e = elegirChip(items[i], nq), chip = e.chip;
      if (e.hit && usados[norm(chip)] && norm(items[i].etiqueta) !== norm(chip)) chip = items[i].etiqueta;
      usados[norm(chip)] = true;
      out.push(chip);
    }
    return out;
  }
  /* ── END MATCHER ── */

  // Registro ANÓNIMO de búsquedas para el informe semanal (Paolo, 25-sep-2026): sin cookies, IP ni identificadores.
  // Se manda la consulta final (no cada tecla, ni tras una pausa: ver anota) y los clics en resultados. Crisis: nada. Médico y sensibles: solo la lista, sin el texto.
  var LOG_URL = 'https://naturadika-buscador.vercel.app/api/log';
  function envia(ev) {
    try {
      var cuerpo = JSON.stringify(ev);
      if (navigator.sendBeacon && navigator.sendBeacon(LOG_URL, new Blob([cuerpo], { type: 'text/plain' }))) return;
      fetch(LOG_URL, { method: 'POST', body: cuerpo, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } });
    } catch (e) {}
  }
  function contexto(fuente) {
    var p = location.pathname;
    return { f: fuente || '', d: window.innerWidth < 750 ? 'movil' : 'escritorio',
      p: p === '/' ? 'home' : p.indexOf('/products/') === 0 ? 'ficha' : p.indexOf('/collections/') === 0 ? 'coleccion' : p.indexOf('/pages/') === 0 ? 'pagina' : 'otra' };
  }
  function resumen(q, res, n) {
    if (res.tipo === 'sensible' && res.lista === 'crisis') return null;
    var ev = { e: 'busqueda', t: res.tipo, n: n || 0 };
    if (res.tipo === 'sensible') ev.l = res.lista || 'sensibles';
    else { ev.q = String(q || '').trim().slice(0, 80); if (res.necesidad) ev.h = res.necesidad.handle; if (res.enrutador) ev.r = 1; }
    return ev;
  }

  var ROUTER_URL = 'https://naturadika-buscador.vercel.app/api/buscador';
  var ROUTER_MS = 4000;
  function consultarEnrutador(q, idx) {
    var ctrl = new AbortController();
    var t = setTimeout(function () { ctrl.abort(); }, ROUTER_MS);
    var necesidades = (idx.necesidades || []).map(function (n) { return { handle: n.handle, cobertura: n.cobertura }; });
    return fetch(ROUTER_URL, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ q: q.slice(0, 120), market: 'fr', necesidades: necesidades }),
      signal: ctrl.signal
    }).then(function (r) { return r.json(); })
      .catch(function () { return { handle: null }; })
      .then(function (j) { clearTimeout(t); return j || { handle: null }; });
  }

  var INDEX = null, cargando = null;
  function cargarIndice() {
    if (INDEX) return Promise.resolve(INDEX);
    if (cargando) return cargando;
    // Caché por hora (25-sep-2026, antes de publicar): el navegador y Shopify reutilizan el índice durante la hora;
    // un cambio en las listas se ve como mucho una hora después.
    cargando = fetch('/pages/ndk-search-index?h=' + Math.floor(Date.now() / 3600000), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { INDEX = j; return j; })
      .catch(function () { cargando = null; return null; });
    return cargando;
  }

  // Orden «más vendidos» de Shopify (templates/collection.ndk-mas-vendidos.liquid). Una petición por página, solo si se pide.
  var VENDIDOS = null, cargandoVendidos = null;
  function cargarVendidos() {
    if (VENDIDOS) return Promise.resolve(VENDIDOS);
    if (cargandoVendidos) return cargandoVendidos;
    cargandoVendidos = fetch('/collections/all?view=ndk-mas-vendidos&sort_by=best-selling', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { VENDIDOS = Array.isArray(j) ? j : []; return VENDIDOS; })
      .catch(function () { cargandoVendidos = null; return null; });
    return cargandoVendidos;
  }
  function topVendidos(handles, idx, n) {
    var porUrl = {}, out = [], i;
    for (i = 0; i < (idx.productos || []).length; i++) porUrl[idx.productos[i].u] = idx.productos[i];
    for (i = 0; i < handles.length && out.length < n; i++) {
      var p = porUrl['/products/' + handles[i]];
      if (p && p.disp !== false) out.push(p);
    }
    return out;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fila(p, etiqueta) {
    return '<a class="ndk-search__row" href="' + esc(p.u) + '">' +
      (p.img
        ? '<img class="ndk-search__thumb" src="' + esc(p.img) + '" alt="" loading="lazy" width="46" height="46">'
        : '<span class="ndk-search__thumb"></span>') +
      '<span class="ndk-search__info">' +
        '<span class="ndk-search__name">' + esc(p.t) + '</span>' +
        (etiqueta ? '<span class="ndk-search__tag">' + esc(etiqueta) + '</span>' : '') +
      '</span></a>';
  }

  function meta(txt) { return '<p class="ndk-search__meta">' + esc(txt) + '</p>'; }
  function esqueleto() {
    var h = '';
    for (var i = 0; i < 3; i++) {
      h += '<div class="ndk-search__row ndk-search__row--carga" aria-hidden="true">' +
           '<span class="ndk-search__thumb"></span>' +
           '<span class="ndk-search__info">' +
             '<span class="ndk-search__barra ndk-search__barra--a"></span>' +
             '<span class="ndk-search__barra ndk-search__barra--b"></span>' +
           '</span></div>';
    }
    return h;
  }
  function msg(txt) { return '<p class="ndk-search__msg">' + esc(txt) + '</p>'; }

  function pintar(res, panel) {
    var h = '', i;
    if (res.tipo === 'vacio') { panel.innerHTML = ''; return; }
    if (res.tipo === 'sensible' || res.tipo === 'cortesia') {
      h = msg(res.respuesta);
    } else if (res.tipo === 'necesidad') {
      var n = res.necesidad, items = n.items || [];
      h = meta(items.length + (items.length === 1 ? ' résultat' : ' résultats'));
      var chips = chipsDeLista(items, res.q);
      for (i = 0; i < items.length; i++) h += fila(items[i], chips[i]);
    } else if (res.tipo === 'producto') {
      h = meta(res.productos.length + (res.productos.length === 1 ? ' résultat' : ' résultats'));
      for (i = 0; i < res.productos.length; i++) h += fila(res.productos[i], res.productos[i].disp === false ? 'épuisé' : null);
    } else if (res.tipo === 'ingrediente') {
      h = meta(res.productos.length + (res.productos.length === 1 ? ' résultat' : ' résultats'));
      for (i = 0; i < res.productos.length; i++) h += fila(res.productos[i], null);
    } else if (res.tipo === 'atajo') {
      h = res.atajo.u
        ? meta('1 résultat') + '<a class="ndk-search__row ndk-search__row--page" href="' + esc(res.atajo.u) + '"><span class="ndk-search__info"><span class="ndk-search__name">' + esc(res.atajo.t) + '</span></span></a>'
        : msg(res.atajo.respuesta || res.atajo.t);
    } else if (res.tipo === 'pagina') {
      h = meta('1 résultat') +
        '<a class="ndk-search__row ndk-search__row--page" href="' + esc(res.pagina.u) + '">' +
        '<span class="ndk-search__info"><span class="ndk-search__name">' + esc(res.pagina.t) + '</span></span></a>';
    } else {
      h = msg('Aucun résultat pour cette recherche.');
    }
    panel.innerHTML = h;
  }

  // Conecta un campo y un panel al motor. Lo usan la cabecera (caja arriba en móvil, barra en escritorio) y el menú
  // lateral ([data-ndk-search-host]): mismo índice, mismas reglas y mismos resultados; solo cambia dónde se pintan.
  function conectar(input, panel, op) {
    op = op || {};
    var t = null, pendiente = null, tReg = null, ultimo = null, enviadas = {}, antes = '';
    function registra() {
      clearTimeout(tReg);
      if (!pendiente) return;
      var ev = pendiente; pendiente = null;
      var clave = (ev.q || ev.l || '') + '|' + ev.t;
      if (enviadas[clave]) return;
      enviadas[clave] = 1;
      var c = contexto(op.fuente); ev.f = c.f; ev.d = c.d; ev.p = c.p;
      envia(ev);
    }
    function anota(q, res) {
      var n = res.necesidad ? (res.necesidad.items || []).length : res.productos ? res.productos.length : (res.tipo === 'atajo' || res.tipo === 'pagina') ? 1 : 0;
      ultimo = resumen(q, res, n);
      // Solo la búsqueda FINAL (Paolo, 26-sep-2026): nada de enviar tras una pausa, que en el móvil caza trozos
      // («re», «retencio»). Se envía con Enter, clic en un resultado, campo vaciado/caja cerrada o al salir de la página.
      pendiente = ultimo ? JSON.parse(JSON.stringify(ultimo)) : null;
    }
    panel.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || !ultimo || ultimo.l) return;
      registra();
      var enlaces = panel.querySelectorAll('a[href]'), pos = 0;
      for (var i = 0; i < enlaces.length; i++) { if (enlaces[i] === a) { pos = i + 1; break; } }
      var c = contexto(op.fuente);
      envia({ e: 'clic', q: ultimo.q, h: ultimo.h, u: (a.getAttribute('href') || '').replace(/^https?:\/\/[^/]+/, '').slice(0, 120), pos: pos, f: c.f, d: c.d, p: c.p });
    }, true);
    function aplicar() {
      clearTimeout(t);
      var q = input.value, previo = antes; antes = q;
      // campo vaciado de golpe (× o cerrar el menú): cuenta la búsqueda que se llegó a ver. Borrando letra a letra no
      // (lo pendiente sería un trozo: «c»). Si sigue escribiendo, lo pendiente era de otra consulta: Enter solo envía lo de ahora.
      if (!q.trim() && previo.trim().length > 1) registra(); else { clearTimeout(tReg); pendiente = null; }
      if (op.alCambiar) op.alCambiar(!!q.trim());
      if (!q.trim()) { panel.innerHTML = ''; return; }
      if (!INDEX) panel.innerHTML = esqueleto();
      t = setTimeout(function () {
        cargarIndice().then(function (idx) {
          if (input.value !== q) return;
          if (!idx) { panel.innerHTML = msg('Impossible de charger la recherche. Recharge la page.'); return; }
          var res = resolve(q, idx);
          if (res.tipo === 'mas-vendidos') {
            if (!VENDIDOS) panel.innerHTML = esqueleto();
            cargarVendidos().then(function (hs) {
              if (input.value !== q) return;
              var top = hs ? topVendidos(hs, idx, 5) : [];
              if (!top.length) { panel.innerHTML = msg('Impossible de charger la recherche. Recharge la page.'); return; }
              pintar({ tipo: 'ingrediente', productos: top }, panel); // filas sin etiqueta: solo producto
              anota(q, { tipo: 'mas-vendidos', productos: top });
            });
            return;
          }
          if (res.tipo !== 'desconocido') { pintar(res, panel); anota(q, res); return; }
          panel.innerHTML = esqueleto();
          consultarEnrutador(q, idx).then(function (j) {
            if (input.value !== q) return;
            var n = null;
            if (j && j.handle) {
              for (var k = 0; k < (idx.necesidades || []).length; k++) { if (idx.necesidades[k].handle === j.handle) { n = idx.necesidades[k]; break; } }
            }
            var final = n ? { tipo: 'necesidad', necesidad: n, q: norm(q), enrutador: true } : { tipo: 'desconocido', q: norm(q), enrutador: true };
            pintar(final, panel); anota(q, final);
          });
        });
      }, 120);
    }
    input.addEventListener('input', aplicar);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); registra(); if (op.alEnter) op.alEnter(); }
    });
    ['pointerdown', 'focus'].forEach(function (ev) {
      input.addEventListener(ev, function () { cargarIndice(); }, { once: true, passive: true });
    });
    window.addEventListener('pagehide', registra);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') registra(); });
    if (input.value.trim()) aplicar();
    return {
      vacia: function () { clearTimeout(t); registra(); input.value = ''; panel.innerHTML = ''; if (op.alCambiar) op.alCambiar(false); }
    };
  }

  // Ejemplos que rotan dentro del campo (Paolo, 25-sep-2026): primero la pregunta del campo y luego ejemplos SOLOS (con la
  // pregunta delante no caben a 375 px). Son búsquedas que ya llevan a su necesidad y a su vista.
  // Animación de rodillo, como un reloj antiguo (Paolo: «movimiento continuo, que nunca se quede en blanco»): la palabra actual
  // sube girando mientras la siguiente entra desde abajo, a la vez. Va en una capa encima del campo (el placeholder no se anima).
  // Con «reducir movimiento» se queda fija la pregunta.
  var EJEMPLOS = ['mieux dormir', 'rétention d’eau', 'chute de cheveux', 'fatigue', 'cellulite', 'magnésium', 'stress'];
  var GIRO_MS = 550, PAUSA_MS = 2000, PAUSA_PREGUNTA_MS = 3000;
  function rotarEjemplos(input) {
    if (!input || input.getAttribute('data-ndk-rota')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    input.setAttribute('data-ndk-rota', '1');
    var base = input.getAttribute('placeholder') || '', campo = input.parentNode;
    if (getComputedStyle(campo).position === 'static') campo.style.position = 'relative';
    var capa = document.createElement('span');
    capa.className = 'ndk-search__ejemplo'; capa.setAttribute('aria-hidden', 'true');
    var a = document.createElement('span'), b = document.createElement('span');
    a.className = b.className = 'ndk-search__ejemplo-t';
    a.textContent = base; b.className += ' is-abajo';
    capa.appendChild(a); capa.appendChild(b);
    campo.insertBefore(capa, input.nextSibling);
    input.setAttribute('placeholder', '');
    function coloca() {
      var cs = getComputedStyle(input), pl = parseFloat(cs.paddingLeft || 0);
      capa.style.left = (input.offsetLeft + pl) + 'px';
      capa.style.width = Math.max(0, input.clientWidth - pl - 4) + 'px';
      capa.style.fontSize = cs.fontSize; capa.style.fontFamily = cs.fontFamily;
    }
    function muestra() { capa.hidden = !!input.value; }
    input.addEventListener('input', muestra);
    input.addEventListener('focus', coloca);
    var textos = [base].concat(EJEMPLOS), i = 0, actual = a, siguiente = b;
    function gira() {
      if (input.offsetParent === null || input.value) { setTimeout(gira, 1000); return; }
      coloca();
      i = (i + 1) % textos.length;
      siguiente.textContent = textos[i];
      // la siguiente espera abajo (sin transición), y las dos se mueven a la vez: nunca hay hueco
      siguiente.className = 'ndk-search__ejemplo-t is-abajo is-quieto';
      void siguiente.offsetWidth;
      siguiente.className = 'ndk-search__ejemplo-t';
      actual.className = 'ndk-search__ejemplo-t is-arriba';
      var t = actual; actual = siguiente; siguiente = t;
      setTimeout(gira, GIRO_MS + (i === 0 ? PAUSA_PREGUNTA_MS : PAUSA_MS));
    }
    coloca(); muestra();
    setTimeout(gira, PAUSA_PREGUNTA_MS);
  }

  function init() {
    var campos = document.querySelectorAll('[data-ndk-search-input]');
    for (var ce = 0; ce < campos.length; ce++) rotarEjemplos(campos[ce]);
    // Menú lateral (y cualquier otro sitio con [data-ndk-search-host]): los resultados salen ahí mismo.
    var hosts = document.querySelectorAll('[data-ndk-search-host]');
    for (var h = 0; h < hosts.length; h++) (function (host) {
      var hi = host.querySelector('[data-ndk-search-input]'), hp = host.querySelector('[data-ndk-search-panel]');
      if (!hi || !hp || host.getAttribute('data-ndk-search-on')) return;
      host.setAttribute('data-ndk-search-on', '1');
      conectar(hi, hp, {
        fuente: 'menu',
        alCambiar: function (hay) { host.classList.toggle('is-buscando', hay); },
        alEnter: function () { hi.blur(); } // en móvil cierra el teclado y deja ver los resultados
      });
    })(hosts[h]);

    var raiz = document.querySelector('[data-ndk-search]');
    if (!raiz || raiz.getAttribute('data-ndk-search-on')) return;
    raiz.setAttribute('data-ndk-search-on', '1');
    var abrir = raiz.querySelector('[data-ndk-search-open]');
    var caja = raiz.querySelector('[data-ndk-search-box]');
    var overlay = raiz.querySelector('[data-ndk-search-overlay]');
    var input = raiz.querySelector('[data-ndk-search-input]');
    var panel = raiz.querySelector('[data-ndk-search-panel]');
    var cerrar = raiz.querySelector('[data-ndk-search-close]');
    var header = raiz.closest('.site-header');
    // ≥ 750 px (tablet y escritorio): la búsqueda se abre en la propia barra de la cabecera, desde la lupa hacia la
    // izquierda, y los resultados cuelgan debajo. < 750 px: caja arriba con la página oscurecida, como hasta ahora.
    var ancho = window.matchMedia('(min-width: 750px)');
    var enBarra = false;
    var conexion = conectar(input, panel, { fuente: 'lupa' });

    function colocaBarra() {
      if (!header) return;
      var hr = header.getBoundingClientRect();
      var logo = header.querySelector('.header-item--logo');
      // la barra empieza justo donde acaba el logo (tapa por completo las categorías); el margen de 16 px va por dentro
      var izq = logo ? logo.getBoundingClientRect().right : hr.left;
      var der = abrir.getBoundingClientRect().left - 12;
      caja.style.left = Math.round(izq - hr.left) + 'px';
      caja.style.width = Math.max(200, Math.round(der - izq)) + 'px';
      caja.style.background = getComputedStyle(header).backgroundColor;
      panel.style.maxHeight = Math.max(240, Math.round(window.innerHeight - Math.max(0, hr.bottom) - 24)) + 'px';
    }
    function abre() {
      enBarra = ancho.matches && !!header;
      caja.hidden = false;
      if (enBarra) {
        colocaBarra();
        header.classList.add('ndk-search-activo');
      } else {
        caja.style.left = caja.style.width = caja.style.background = panel.style.maxHeight = '';
        overlay.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }
      abrir.setAttribute('aria-expanded', 'true');
      cargarIndice();
      input.focus();
    }
    function cierra(devolverFoco) {
      if (caja.hidden) return;
      caja.hidden = true; overlay.hidden = true;
      if (header) header.classList.remove('ndk-search-activo');
      abrir.setAttribute('aria-expanded', 'false');
      if (!document.querySelector('[data-ndk-drawer]:not([hidden])')) document.documentElement.style.overflow = '';
      conexion.vacia();
      if (devolverFoco && enBarra) abrir.focus();
    }
    function abrirCon(q) {
      abre();
      if (q) { input.value = q; input.dispatchEvent(new Event('input', { bubbles: true })); }
    }

    ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) {
      abrir.addEventListener(ev, function () { cargarIndice(); }, { once: true, passive: true });
    });

    abrir.addEventListener('click', function () { caja.hidden ? abre() : cierra(true); });
    overlay.addEventListener('click', function () { cierra(false); });
    if (cerrar) cerrar.addEventListener('click', function () { cierra(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !caja.hidden) cierra(true); });
    // barra de escritorio: se cierra al hacer clic o mover el foco fuera de ella (captura: nada del theme lo intercepta)
    function fuera(el) { return !caja.contains(el) && !abrir.contains(el); }
    document.addEventListener('click', function (e) { if (!caja.hidden && enBarra && fuera(e.target)) cierra(false); }, true);
    document.addEventListener('focusin', function (e) { if (!caja.hidden && enBarra && fuera(e.target)) cierra(false); }, true);
    window.addEventListener('resize', function () {
      if (caja.hidden) return;
      if (ancho.matches !== enBarra) { cierra(false); return; }
      if (enBarra) colocaBarra();
    });
    // al cruzar los 750 px con la búsqueda abierta se cierra (barra y caja tienen posiciones distintas)
    function alCambiarAncho() { if (!caja.hidden && ancho.matches !== enBarra) cierra(false); }
    if (ancho.addEventListener) ancho.addEventListener('change', alCambiarAncho); else if (ancho.addListener) ancho.addListener(alCambiarAncho);

    window.ndkSearch = { resolve: resolve, norm: norm, elegirChip: elegirChip, chipsDeLista: chipsDeLista, abrir: abrirCon, indice: function () { return INDEX; } };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
